var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#DFFE00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.254 364H163.683V148.727H243.149C265.083 148.727 283.968 153.037 299.805 161.656C315.713 170.205 327.976 182.539 336.595 198.656C345.214 214.704 349.524 233.904 349.524 256.259C349.524 278.683 345.214 297.954 336.595 314.071C328.046 330.188 315.818 342.557 299.911 351.176C284.003 359.725 265.118 364 243.254 364ZM215.714 319.642H241.257C253.31 319.642 263.506 317.61 271.845 313.545C280.254 309.411 286.596 302.719 290.871 293.469C295.215 284.149 297.388 271.745 297.388 256.259C297.388 240.772 295.215 228.438 290.871 219.259C286.526 210.009 280.114 203.351 271.635 199.287C263.226 195.152 252.855 193.085 240.521 193.085H215.714V319.642Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMode);
export default __webpack_public_path__ + "static/media/mode.844d139bcbb617c77783839e9ec42a0c.svg";
export { ForwardRef as ReactComponent };